namespace Areas.Account.Funding{
    "use strict";
    let fundTransferId: number;
    let fundTransferDetailId: number;
    let runQuery: boolean = false;

    export function getFundTransferId() {
        return fundTransferId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onFundingGridSelectionChanged(e: any) {

        let rowData: any = e.selectedRowsData[0];

        let rowForm: any = $("#FundingForm").dxForm("instance");
        rowForm.option("formData", rowData);


        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            runQuery = true;
            fundTransferId = selectedRows[0].fundTransferId;
            Areas.refreshGrid("FundingDetailGrid");
        }
    }

    export function onFundingContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);

    }

    export function updateFundingProfile() {
        const form = $("#FundingForm").dxForm("instance");
        const newData: any = form.option("formData");

        const url = `/Account/FinanceFunding/Put/${fundTransferId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

}